var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.marketAttributes &&
    (_vm.marketAttributes.earn || _vm.marketAttributes.redeem)
      ? _c(
          "div",
          {
            staticClass: "ns-loyalty-information",
            class: {
              "ns-loyalty-information__product-detail": _vm.productDetail
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "ns-loyalty-information__message",
                attrs: { itemprop: "loyaltyInformation" }
              },
              [
                _c("div", { staticClass: "loyalty_options" }, [
                  _c("div", { staticClass: "rewards_available" }, [
                    _c("div", { staticClass: "rewards_icon" }, [
                      _c("img", {
                        attrs: {
                          src: _vm.loyaltyStatusAndLinks.siteUrl + _vm.coinUrl
                        }
                      })
                    ]),
                    _vm._v(" "),
                    !_vm.isLoggedIn || !_vm.isOptedIn
                      ? _c("div", { staticClass: "rewards_message" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  _vm.loyaltyStatusAndLinks.siteUrl +
                                  _vm.loyaltyStatusAndLinks.landingPage
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.loyaltyStatusAndLinks.notOptedIn) +
                                  "\n            "
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isLoggedIn && _vm.isOptedIn
                      ? _c("div", { staticClass: "rewards_message" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  _vm.loyaltyStatusAndLinks.siteUrl +
                                  _vm.loyaltyStatusAndLinks.dashboardPage
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.dashboardLinkMessage) +
                                  "\n            "
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ])
                ])
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }